<template>
  <h1>Cześć, {{ user?.first_name ?? '' }}! <img src="@/assets/img/icons/emoji-hello.svg?url"></h1>
  <DashboardAnnounces />
  <div class="dashboard">
    <div class="container">
      <DashboardStats />
      <DashboardActivity />
    </div>
  </div>
</template>

<script lang="ts" setup>
  import { computed, onMounted } from 'vue'

  import DashboardActivity from '@/pages/dashboard/components/DashboardActivity.vue'
  import DashboardAnnounces from '@/pages/dashboard/components/DashboardAnnounces.vue'
  import DashboardStats from '@/pages/dashboard/components/DashboardStats.vue'
  import { useDashboardStore } from '@/store/dashboardStore'
  import { useGlobalStore } from '@/store/globalStore'
  import { reportError } from '@/utils/reportError'

  const globalStore = useGlobalStore()
  const dashboardStore = useDashboardStore()
  const user = computed(() => globalStore.user)

  const startDashboardData = async () => {
    try {
      await Promise.all([dashboardStore.fetchStats(), dashboardStore.fetchPatientsOptions()])
    } catch (error) {
      reportError(error, 'Error while fetching dashboard data')
    }
  }
  onMounted(() => {
    void startDashboardData()
  })
</script>

<style scoped>
  .announces {
    width: 100%;
  }

  .announce {
    margin-bottom: 16px;
    background: #fff;
    border-radius: 8px;
  }

  .announce__inner {
    position: relative;
    padding: 16px;
  }

  .announces button {
    cursor: pointer;
    background: transparent;
  }

  .announces h2 {
    position: relative;
    display: flex;
    align-items: center;
    margin: 0 0 8px;
    font-family: Montserrat-Medium;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 28px;
    color: var(--color-primary-text);
    text-align: left;
  }

  .announces h2 .material-icon {
    position: absolute;
    left: -21px;
  }

  .announce p,
  .announce .announce__content {
    margin: 0;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    color: var(--color-secondary-text);
    text-align: left;
    letter-spacing: -0.006em;
  }

  .announce p {
    padding: 0 40px 0 0;
  }

  .announce .announce__content {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }

  .announce .btt-green {
    display: block;
    padding: 8px 32px;
    font-family: Montserrat-Medium;
    font-size: 14px;
    font-style: normal;
    line-height: 20px;
    color: #fff;
    text-align: left;
    letter-spacing: -0.006em;
    text-decoration: none;
    background: var(--color-main-100);
    border-radius: 4px;
    box-shadow: 0 1px 2px 0 #0000001f;
    transition: all 0.2s ease;
  }

  .announce .btt-green:hover {
    background: #008183;
  }

  .dashboard {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    padding: 17px 16px;
    background: #fff;
    border-radius: 8px;
  }

  .container {
    display: flex;
    flex-direction: column;
    width: 100%;
  }

  h1 {
    padding: 0 0 0 16px;
    margin: 0 0 15px;
    font-family: Montserrat-SemiBold;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 36px;
    text-align: left;
    letter-spacing: -0.021em;
  }

  h1 img {
    width: 25px;
  }

  .add-button-icon {
    margin-right: 7px;
    vertical-align: middle;
    pointer-events: none;
  }

  .add-button-text {
    display: inline-block;
    line-height: 14px;
    vertical-align: middle;
  }

  #modal-create-group-button .add-button-icon {
    color: var(--color-main-100);
  }

  #modal-create-group-button:hover .add-button-icon :deep(i) {
    color: #fff;
  }

  .diet-list-search-bar {
    padding: 27px 18px;
    margin-top: 38px;
    margin-bottom: 28px;
  }

  .diet-list-search-bar :deep(.material-icon),
  .diet-list-search-bar :deep(.material-icon) .material-icon__image {
    color: var(--color-tertiary-text);
    transition: none;
  }

  .diet-list-search-bar :deep(.material-icon.red-clear-icon),
  .diet-list-search-bar :deep(.material-icon.red-clear-icon) .material-icon__image {
    color: var(--color-destructive-100);
    transition: none;
  }

  .diet-list-search-bar :deep(.placeholder.with-big-font),
  .diet-list-search-bar :deep(input) {
    top: 55%;
    margin-left: 0;
    font-family: Montserrat-Regular;
    font-size: 16px;
    color: var(--color-primary-text);
  }
</style>
